import { graphql } from "gql";

const INTERNAL_ADMIN_DISTRIBUTION_GROUP_LIST_QUERY = graphql(`
  query InternalAdminDistributionGroupList(
    $organizationId: ID!
    $input: InternalAdminDistributionGroupListInput!
  ) {
    internalAdminDistributionGroupList(
      organizationId: $organizationId
      input: $input
    ) {
      ...InternalAdminDistributionGroup
    }
  }
`);

export default INTERNAL_ADMIN_DISTRIBUTION_GROUP_LIST_QUERY;
